"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var antd_1 = require("antd");
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var PermissionContext_1 = __importDefault(require("../../contexts/PermissionContext"));
var utils_1 = require("../../helpers/utils");
var FormItem_1 = require("../FormItem");
var Search = antd_1.Input.Search;
var FormSearch = function (props) {
    var name = props.name, placeholder = props.placeholder, onInputChange = props.onChange, searchProps = __rest(props, ["name", "placeholder", "onChange"]);
    var t = react_i18next_1.useTranslation().t;
    return (react_1.default.createElement(PermissionContext_1.default.Consumer, null, function (_a) {
        var allowEdit = _a.allowEdit;
        return (react_1.default.createElement(formik_1.Field, { name: name }, function (_a) {
            var _b = _a.field, value = _b.value, onChange = _b.onChange, onBlur = _b.onBlur;
            return (react_1.default.createElement(Search, __assign({ placeholder: placeholder && t(placeholder), disabled: !allowEdit, enterButton: utils_1.toCapitalize(t('ui.commons.search')), name: name, value: value, onChange: function (e) {
                    onChange(e);
                    if (onInputChange)
                        onInputChange(e);
                }, onBlur: onBlur }, searchProps)));
        }));
    }));
};
exports.default = FormItem_1.withFormItem(FormSearch);
